import React, { useState, useRef, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const colorCodedReadingEase = (reading_ease) => {
  if (reading_ease == null) return <span className="text-muted-foreground">—</span>;
  const cls = reading_ease > 60 ? 'text-green-600 font-bold' :
              reading_ease >= 30 ? 'text-orange-500 font-bold' :
              'text-red-600 font-bold';
  return <span className={cls}>{reading_ease.toFixed(1)}</span>;
};

export const CommentDetailPopover = ({ comment, children }) => {
  const [open, setOpen] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [open]);

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(prev => !prev);
  };

  return (
    <span className="relative inline-block" ref={popoverRef}>
      <span onClick={toggle} className="cursor-pointer">
        {children}
      </span>
      {open && (
        <div className="absolute z-50 mt-2 w-80 sm:w-96 left-1/2 -translate-x-1/2 md:left-0 md:translate-x-0">
          <Card className="shadow-lg border bg-popover text-popover-foreground">
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-semibold flex items-center justify-between">
                <span>Détail du commentaire #{comment.comment_id}</span>
                <button
                  onClick={() => setOpen(false)}
                  className="text-muted-foreground hover:text-foreground text-lg leading-none"
                  aria-label="Fermer"
                >
                  &times;
                </button>
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 pt-0 text-sm">
              <div>
                <span className="text-muted-foreground text-xs uppercase tracking-wider">Commentaire</span>
                <p className="mt-1 whitespace-pre-wrap">{comment.comment_text}</p>
              </div>
              <div className="grid grid-cols-2 gap-x-4 gap-y-2">
                <div>
                  <span className="text-muted-foreground text-xs uppercase tracking-wider">Stock</span>
                  <p className="font-semibold">{comment.fk_stock_symbol}</p>
                </div>
                <div>
                  <span className="text-muted-foreground text-xs uppercase tracking-wider">Prédicteur</span>
                  <p>{comment.predictorname || 'Nom inconnu'}</p>
                </div>
                <div>
                  <span className="text-muted-foreground text-xs uppercase tracking-wider">Direction</span>
                  <p>{comment.direction}</p>
                </div>
                <div>
                  <span className="text-muted-foreground text-xs uppercase tracking-wider">Time frame</span>
                  <p>{typeof comment.time_frame === 'string' ? comment.time_frame : JSON.stringify(comment.time_frame)}</p>
                </div>
                <div>
                  <span className="text-muted-foreground text-xs uppercase tracking-wider">Date</span>
                  <p>{comment.created_at ? new Date(comment.created_at).toLocaleDateString('fr-FR') : '—'}</p>
                </div>
                <div>
                  <span className="text-muted-foreground text-xs uppercase tracking-wider">Change</span>
                  <p>{comment.percentage_change != null ? `${comment.percentage_change}%` : '—'}</p>
                </div>
                <div>
                  <span className="text-muted-foreground text-xs uppercase tracking-wider">Reading Ease</span>
                  <p>{colorCodedReadingEase(comment.reading_ease)}</p>
                </div>
                <div>
                  <span className="text-muted-foreground text-xs uppercase tracking-wider">Grade Level</span>
                  <p>{comment.grade_level != null ? comment.grade_level.toFixed(1) : <span className="text-muted-foreground">—</span>}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </span>
  );
};
